<script>
import { onMounted } from 'vue';
export default {
	name: 'AnchorTag',
	inheritAttrs: false,
};
</script>

<script setup>
import { useGlobalAEMState } from '~/logic/aem/global-aem-state.js';
import Anchor from '~/logic/helpers/Anchor.js';
import { useRouteHash } from '~/logic/composables/useRouteHash.js';

const props = defineProps({
	anchorLabel: { type: String, default: '' },
	anchorId: { type: String, default: '' },
});
const emit = defineEmits([
	
]);


const { isEditorMode } = useGlobalAEMState();
const rootEl = ref(null);
const { hash } = useRouteHash();


const handleHashChange = (newValue) => {
	if (newValue !== props.anchorId) return;
	Anchor.activate(props.anchorId, { updateHash: false });
};

onMounted(() => {
	if (props.anchorId) {
		Anchor.register(props.anchorId, rootEl.value);
	}
	setTimeout(() => {
		handleHashChange(hash.value);
	}, 500);
});

watch(hash, handleHashChange);


</script>



<template>
<div v-if="isEditorMode" class="generic-container flex items-center">
	<div class="mr-4">
		<div class="inline-flex items-center bg-secondary-gold-base rounded px-3 text-white">
			<icon-far-anchor class="mr-2 text-2xl fill-current" />
			<h4 class="uppercase">Anchor Tag</h4>
		</div>
	</div>
	<div class="flex text-lg mb-1.5">
		<p class="mr-4"><strong>Anchor Label</strong>: {{ props.anchorLabel }}</p>|
		<p class="ml-4 mr-4"><strong>Anchor Tag</strong>: {{ props.anchorId ? `#${props.anchorId}` : '' }}</p>
	</div>
</div>
<div ref="rootEl" class="AnchorTag" :data-anchor-id="props.anchorId"></div>
</template>



<style scoped lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';

.AnchorTag {
	scroll-margin-top: var(--headerHeight);
}

</style>
